<template>
  <Modal :id="'cmp-b2b-reset-password'" @cancelled="onCancel">
    <template slot="header">Reset your password</template>
    <template slot="body">
      <div v-if="isResetPassword === null" class="body-container">
        <div class="form-group">
          <TextField
            id="username"
            class="m1"
            v-bind="textFieldConfig"
            :value="resetPassword.username"
            required
            showValidationIcons
            :placeholder="$t('user name')"
            @validated="onValidation"
            @valuechanged="onTextFieldValueChange"
          />
        </div>
      </div>
      <div v-if="isResetPassword !== null" class="body-container">
        <div v-if="isResetPassword === false" class="reset-error">
          <span style="color: red" class="material-icons"> error </span>
          <span style="font-size: 100%; color: red">User doesn't exist</span>
        </div>

        <div class="reset-success" v-if="isResetPassword === true">
          <span style="color: #0087ff" class="material-icons">
            check_circle
          </span>
          <span style="font-size: 100%; color: #0087ff"
            >Password reset successfully,</span
          >
          <span style="font-size: 100%; color: #0087ff"
            >Please check your email.</span
          >
        </div>
      </div>
    </template>

    <template slot="options">
      <button
        v-if="isResetPassword === null"
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        class="dt-button v1 s6"
        @click.stop="onOkClick"
      >
        Reset
      </button>
      <button class="dt-button s6" @click.stop="onCancel">Close</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import * as ActionTypes from "../../modules/b2b/store/types.js";
import { B2BStoreNamespace as storeNS } from "../../modules/b2b/store/index";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { createValidator } from "@plugins/text-field";
export default {
  components: {
    Modal,
    InputField,
  },

  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
      },
      validationResult: {},
      userValidator: [
        createValidator({
          name: "userValidation",
          validatorFn: this.checkUserExist,
          errorMessage: "User doesn't exist",
        }),
      ],
    };
  },
  computed: {
    ...mapGetters(storeNS, {
      resetPassword: "resetPassword",
      isResetPassword: "isResetPassword",
    }),
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.B2B_RESET_PASSWORD]: ActionTypes.B2B_RESET_PASSWORD,
    }),
    ...mapMutations(storeNS, {
      [ActionTypes.B2B_SET_RESET_PASSWORD]: ActionTypes.B2B_SET_RESET_PASSWORD,
    }),
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },

    onOkClick: async function () {
      this[ActionTypes.B2B_RESET_PASSWORD]();
    },

    onTextFieldValueChange: function (name, value) {
      this.resetPassword[name] = value;
    },
    checkUserExist: function () {
      return this.isResetPassword;
    },
  },
};
</script>

<style lang="scss">
.cmp-b2b-reset-password {
  .reset-error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .reset-success {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
